import { render, staticRenderFns } from "./CustomPermissionDetailList.vue?vue&type=template&id=a5ab0e2c&"
import script from "./CustomPermissionDetailList.vue?vue&type=script&lang=js&"
export * from "./CustomPermissionDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports